// extracted by mini-css-extract-plugin
export default {"text_container":"MobilePrivacy_text_container__ALKn4"};